import axiosInstance from "../config/axiosInterceptor";

export async function getEventStatus() {
  return await axiosInstance.get("/api/EventStatus");
}

export async function getEventStatusByNodeId(nodeId) {
  return await axiosInstance.get(`/api/EventStatus/ByNodeId/${nodeId}`);
}
